import Tab from 'bootstrap/js/dist/tab';

export default class CustomTab {
    constructor(el) {
        this.DOM = { el: el };
        this.target = this.DOM.el.dataset.tabTarget;

        this.initEvents();
    }

    initEvents() {
        this.DOM.el.addEventListener('click', () => {
            const targetElement = document.querySelector(this.target);
            if (targetElement) {
                const tab = new Tab(targetElement);
                tab.show();
            }
        });
    }
}

const tabTargetNodes = Array.from(document.querySelectorAll('[data-tab-target]'));
if (tabTargetNodes !== null) {
    tabTargetNodes.forEach((node) => { new CustomTab(node); });
}
